import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    gap: 10,
    [theme.breakpoints.down(800)]: {
      flexDirection: 'column',
    },
  },
  button: {
    width: 362,
    height: 98.5,
    '&:hover': {
      color: theme.palette.primary.main,
    },
    [theme.breakpoints.down(800)]: {
      height: '76px !important',
    },
    [theme.breakpoints.down(600)]: {
      height: '3.5rem',
    },
    [theme.breakpoints.down(425)]: {
      width: 'unset !important',
    },
  },
  addChildrenButton: {
    height: 98.5,
    padding: 0,
    '& > .MuiButton-label': {
      display: 'contents',
    },
    '&:hover': {
      border: '1px solid transparent',
    },
    [theme.breakpoints.down(425)]: {
      height: '7rem',
    },
  },
  icon: {
    marginRight: 6,
  },
  offerContainer: {
    display: 'flex',
    alignItems: 'center',
    borderTopRightRadius: '0.5rem',
    borderTopLeftRadius: '0.5rem',
    justifyContent: 'space-between',
  },
  offerTitle: {
    backgroundColor: '#830600',
    fontSize: '1rem',
    color: theme.palette.white.main,
    borderTopLeftRadius: '0.5rem',
    clipPath: 'polygon(100% 0%, 91% 51%, 100% 100%, 0 100%, 0% 50%, 0 0)',
    flexBasis: '40%',
    display: 'flex',
    alignItems: 'center',
    '& > img': {
      paddingLeft: '.3rem',
      paddingRight: '.2rem',
    },
    [theme.breakpoints.down(800)]: {
      clipPath: 'polygon(100% 0%, 96% 51%, 100% 100%, 0 100%, 0% 50%, 0 0)',
    },
  },
  offerInfoBox: {
    width: '100%',
    height: '100%',
  },
  description: {
    padding: '7px 15px',
    textAlign: 'left',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  descriptionHead: {
    display: 'flex',
  },
  addMemberText: {
    fontWeight: 'bold',
    textAlign: 'center',
  },
  addNewChildInfo: {
    fontSize: '0.75rem',
    color: theme.palette.gray.inputPlaceholder,
  },
}));

export default useStyles;
